import { getRequirementId, isRequirementRef } from '../../../../../util/applicationRequirement.util'

// An application requirement is just a name, so an "application:<name>" field value already
// carries its own readable label — this builds a { "application:<name>": name } lookup for every
// such value found, so a review screen can show the name instead of the raw sentinel.
const buildApplicationRequirementOptionsMap = (values = []) =>
  Object.fromEntries(values.filter(isRequirementRef).map((value) => [value, getRequirementId(value)]))

export default buildApplicationRequirementOptionsMap
